import React from 'react';

import { useTranslation } from '@crehana/i18n';
import { PrimaryButton } from '@crehana/ui';
import { createUrlWithSourceQueryParams } from '@crehana/analytics';

export const getFeatureFlagFromInitialState = (featureFlagName: string) =>
  window && window.__INITIAL_STATE__ && window.__INITIAL_STATE__.feature_flags
    ? window.__INITIAL_STATE__.feature_flags.find(
        f => f.key === featureFlagName,
      )
    : false;

const BannerPremiumTrialMobile = () => {
  const { t } = useTranslation();
  const isSOFEEnabled = getFeatureFlagFromInitialState(
    'enable_sofe_membership',
  );

  const urlWithSource = createUrlWithSourceQueryParams({
    url: '/registro/',
    source: 'Catalog',
    sourceDetail: 'Banner Premium Trial CTA',
  });

  const redirectTo = () => {
    window.location.href = urlWithSource;
  };

  if (!isSOFEEnabled) return null;

  return (
    <div
      className="w-full py-56 px-24 text-center"
      css={`
        min-height: 380px;
        background-color: #0f1124;
      `}
    >
      <h2 className="font-h1 text-white mb-16 ">{t('BANNER_FREE_TITLE')}</h2>
      <p className="font-subtitle1 text-white mb-36">
        {t('BANNER_FREE_SUBTITLE')}
      </p>
      <PrimaryButton
        className="m-auto"
        darkMode
        onClick={redirectTo}
        label={t('BANNER_FREE_CTA')}
      />
    </div>
  );
};

export default BannerPremiumTrialMobile;
